module.exports = __webpack_public_path__ + "img/clearance-homepage-clearance-mob-compressed.673f5c8.png";